module.exports = __webpack_public_path__ + "static/media/left-outer-join-icon.2a967a1b.svg";